import { forwardRef, ReactElement, Ref, Suspense, useMemo } from 'react';

import { Dialog as MuiDialog, DialogProps, Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-helpers';

import { closeModal } from '@/store/actions/core.actions';

import { DictionnaryModals } from './DictionnaryModals';

const Portal = styled(MuiDialog)<DialogProps & { $isScrollDisabled?: boolean; $bgColor?: string }>`
  margin-top: 3rem;
  z-index: 300 !important;
  & .MuiDialog-paper {
    background-color: ${({ $bgColor, theme }) => $bgColor ?? theme.palette.white};
    overflow-y: hidden;
    ${({ $isScrollDisabled }) => $isScrollDisabled && 'overflow: hidden'};
    ${({ $isScrollDisabled }) => !$isScrollDisabled && 'height: 100%'};
  }

  & .MuiDialog-paper > div {
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
  & > div {
    min-width: 22rem !important;
  }
`;

const Transition = forwardRef((props: TransitionProps & { children?: ReactElement }, ref: Ref<unknown>) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

Transition.displayName = 'Transition';

export const PortalModal = () => {
  const dispatch = useAppDispatch();

  const isOpen = useAppSelector((state) => state.modal.isOpen);
  const modalProps = useAppSelector((state) => state.modal.currentModal);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const Modal = useMemo(() => (modalProps?.keyModal ? DictionnaryModals[modalProps.keyModal] : null), [modalProps]);

  if (!isOpen || !modalProps?.keyModal) return null;

  return (
    <Portal
      data-testid={`dialog-${modalProps?.keyModal}`}
      open={isOpen}
      $bgColor={modalProps?.dialogProps?.backgroundColor}
      $isScrollDisabled={modalProps?.dialogProps?.isScrollDisabled ?? true}
      TransitionComponent={Transition}
      onClose={handleCloseModal}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      {...modalProps?.dialogProps}
      disableEnforceFocus
    >
      <Suspense fallback={<div />}>
        <Modal onClose={handleCloseModal} {...modalProps.props} {...modalProps?.dialogProps} />
      </Suspense>
    </Portal>
  );
};
